<div class="lightBox createpage block" *ngIf="!showLoader">
  <div class="headerLight">
    <div (click)="resetForm()" class="close fl spImg"></div>
  </div>
  <div class="lightContent">
    <div class="addUser">
      <h3>{{(id !== null) ? "Update External Page" : "Create a External Page"}}</h3>
      <div class="authorName fl100">
        <div class="">
          <label>Name</label>
        </div>
        <div class="Input">
          <input type="text" id="pageExternalNameText" [(ngModel)]="formData.name" class="textBox"
            placeholder="Add page’s name here">
        </div>
      </div>
      <div class="authorName fl100">
        <div class="">
          <label>External URL</label>
        </div>
        <div class="Input">
          <input type="text" id="pageExternalURL" [(ngModel)]="formData.externalUrl" class="textBox"
            placeholder="Add URL here">
        </div>
      </div>
      <div class="authorName fl100">
        <div class="">
          <label>HTML CSS class</label>
        </div>
        <div class="Input">
          <input type="text" [(ngModel)]="formData.cssHTMLClass" class="textBox"
            placeholder="Add Class Name here">
        </div>
      </div>
      <ng-container *ngIf="sharedService.isdomainConfig('pages','pageSubtype')">
        <div class="authorName fl100">
          <div class="">
            <label>Page Subtype</label>
          </div>
          <div class="Input">
            <tags-creator [textEdit]="formData.pageSubtype && formData.pageSubtype.length > 0" [autoSuggest]="true" [autocompletelist]="(formData.pageSubtype && formData.pageSubtype.length > 0) ? [] : ['brand','model']"
              [data]="marketList" [noMinReq]="(formData.pageSubtype && formData.pageSubtype.length > 0) ? 'false' : 'true'"
            [displayText]="'Enter Page type...'" (clickfn)="customFunc($event)" (changefn)="setType('pageSubtype', $event)"
            ></tags-creator>
          </div>
        </div>
        
        <div class="authorName fl100">
          <div class="">
            <label>Page Subtype Category</label>
          </div>
          <div class="Input">
            <tags-creator [textEdit]="formData.pageSubtypeCategory && formData.pageSubtypeCategory.length > 0" [autoSuggest]="true" [autocompletelist]="(formData.pageSubtypeCategory && formData.pageSubtypeCategory.length > 0) ? [] : autocompletelist"
              [data]="marketList" [noMinReq]="(formData.pageSubtypeCategory && formData.pageSubtypeCategory.length > 0) ? 'false' : 'true'"
          [displayText]="'Enter Page type...'" (clickfn)="customFunc($event)" (changefn)="setType('pageSubtypeCategory', $event)"
          ></tags-creator>
          </div>
        </div>
      </ng-container>
      <div class="authorName fl100">
        <div class="">
          <label>Auto-Backlinking Enabled</label>
        </div>
        <label class="switch" tabindex="0">
          <input
            type="checkbox"
            (click)="toggleSwitch('autobacklink')"
            [checked]="formData.toBeAutobacklink"/>
          <span class="slider round"></span>
        </label>
      </div>
      <div class="authorName fl100">
        <div class="">
          <label>No Follow</label>
        </div>
        <label class="switch" tabindex="0">
          <input
            type="checkbox"
            (click)="toggleSwitch('noFollow')"
            [checked]="formData.noFollow"/>
          <span class="slider round"></span>
        </label>
      </div>
    </div>

    <div class="fr wid100 right">
      <button type="button" name="cancel" (click)="resetForm()" class="cancel gray mtb15 ml10">Cancel</button>
      <button type="button" name="add" id="pageExternalCreateButton" (click)="savePage()" class="add blue mtb15 ml10 mr30">{{(id !== null) ? "Save" : "Create"}}</button>
    </div>
    <div class="clearBoth"></div>
  </div>
</div>

<div class="loaderimage block" *ngIf="showLoader">
  <div class="imagepreloader">
    <!-- <h3>TRANSLATING...</h3> -->
    <div class="a" style="--n: 5;">
      <div class="dot dot1" style="--i: 0;"></div>
      <div class="dot dot2" style="--i: 1;"></div>
      <div class="dot dot3" style="--i: 2;"></div>
      <div class="dot dot4" style="--i: 3;"></div>
    </div>
  </div>
</div>